export type CourseExamId = number;
export enum ExamSectionType {
  WRITING = 'writing',
  PRACTICAL = 'practical',
}

export type ExamWritingSectionId = number;
export type ExamPracticalSectionId = number;
export type ExamPracticalSectionSubmissionToken = string;
export type ExamPracticalSectionSubmissionId = number;
